import React from 'react';
import { CheckCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface RepairFeedbackBannerProps {
  message: string;
  onDismiss: () => void;
}

const RepairFeedbackBanner: React.FC<RepairFeedbackBannerProps> = ({ message, onDismiss }) => (
  <div className="rounded-md border border-green-500/30 bg-green-500/10 p-4 flex items-start justify-between gap-3">
    <div className="flex items-start gap-2">
      <CheckCircleIcon className="h-5 w-5 text-green-400 flex-shrink-0 mt-0.5" />
      <p className="text-sm text-green-200">{message}</p>
    </div>
    <button
      type="button"
      onClick={onDismiss}
      className="text-green-400 hover:text-green-300"
      aria-label="Dismiss"
    >
      <XMarkIcon className="h-5 w-5" />
    </button>
  </div>
);

export default RepairFeedbackBanner;
